import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import { sidebarStrings } from '../../constants/strings';
import { Icon } from '../Icon';
import { SideBarContent, SideBarContentProps } from './Content';
import { sidebarClasses } from './styles';

type SideBarMobileDrawerProps = SideBarContentProps & {
  open: boolean;
  onClose: () => void;
};

export function SideBarMobileDrawer({
  open,
  onClose,
  ...contentProps
}: SideBarMobileDrawerProps) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40 lg:hidden" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-y-0 left-0 flex">
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in-out duration-300"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in-out duration-200"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <Dialog.Panel className={sidebarClasses.drawerPanel}>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  aria-label={sidebarStrings.mobileNavCloseLabel}
                  className={sidebarClasses.drawerCloseButton}
                >
                  <Icon icon="close" width={24} height={24} />
                </button>
              </div>
              <SideBarContent {...contentProps} />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
